<script>
    import EditableCellInput from './EditableCellInput.vue';

    export default {

        props: ['dataset'],

        components: {EditableCellInput},

        data() {
            return {
                item: this.dataset,
                url: '/items/translations/'
            }
        },

        methods: {
            onDataHasChanged() {
                console.log('Ricevuto!')
            },

            destroy(item) {
                swal.fire({
                    title: "Sei sicuro?",
                    text: "Potresti generare un casino inenarrabile!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Fottesega! Cancella!'
                }).then(() => {
                    axios.delete('/items/' + item.id_articolo)
                        .then(() => {
                            this.$emit('item_has_been_deleted', item)
                        })
                        .catch((error) => {
                            swal.fire('Disastro!', 'Hai fatto un casino!!', 'error');
                        })

                });
            }
        },

        render() {
            return this.$scopedSlots.default({
                item: this.item,
                url: this.url,
                destroy: this.destroy,
                onDataHasChanged: this.onDataHasChanged
            })
        }
    }
</script>